<template>
  <v-container>
    <div class="text-h5 text-center mb-4">Revisión de planes de acción</div>

    <v-row class="mb-3" align="center">
      <v-col cols="12" sm="4">
        <v-select :items="[{ text: 'Pendientes', value: false }, { text: 'Revisadas', value: true }]"
          v-model="filtros.revisado" label="Estado" dense clearable @change="loadData" />
      </v-col>

      <v-col cols="12" sm="4">
        <v-select :items="anios" v-model="filtros.year" label="Año" dense clearable @change="loadData" />
      </v-col>
      <!-- Kram filtro por empleado perteneciente a perId -->
      <v-col cols="12" sm="4">
        <v-autocomplete v-model="filtros.empleadoSeleccionado" :items="empleados" item-text="PerNom" item-value="PerId"
          label="Empleado" clearable dense :multiple="false" @change="onEmpleadoChange" />

      </v-col>

      <v-data-table :headers="headers" :items="rows" :loading="loading" item-key="ValoracionAccionId" show-select
        v-model="seleccion" dense mobile-breakpoint="0">
        <template v-slot:item.FechaValoracion="{ item }">
          {{ formatDate(item.FechaValoracion) }}
        </template>
        <template v-slot:item.Revisado="{ item }">
          <v-chip x-small :color="item.Revisado ? 'green' : 'orange'" dark>
            {{ item.Revisado ? 'Revisado' : 'Pendiente' }}
          </v-chip>
        </template>
        <template v-slot:item.TextoAccion="{ item }">
          <div class="text-truncate" style="max-width: 520px;">{{ item.TextoAccion }}</div>
        </template>

        <!-- //kram cambio para que la fecha sea editable -->
        <template v-slot:item.FechaRevision="{ item }">
          <v-menu v-model="item.menu" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="item.FechaRevisionFormatted"  readonly v-bind="attrs"
                v-on="on" dense hide-details></v-text-field>
              <span v-if="item.FechaRevision !== item.FechaRevisionOriginal" class="text-caption red--text mt-1">
                modificada
              </span>
            </template>

            <v-card>
              <v-date-picker v-model="item.FechaRevision" no-title scrollable
                @input="item.FechaRevisionEdited = true"></v-date-picker>

              <v-card-actions class="justify-center">
                <v-btn small color="primary" :disabled="!item.FechaRevisionEdited" @click="onGuardarFecha(item)">
                  Cambiar fecha
                </v-btn>
                <v-btn small color="grey" :disabled="!item.FechaRevisionEdited" @click="onCancelarFecha(item)">
                  Cancelar
                </v-btn>
              </v-card-actions>
              <v-card-text v-if="item.FechaRevisionEdited" class="text-caption red--text">
                ¿Está seguro de modificar la fecha?
              </v-card-text>
            </v-card>
          </v-menu>

        </template>


      </v-data-table>

      <v-row class="mt-3" justify="end">
        <v-btn class="mr-2" small color="success" :disabled="seleccion.length === 0" @click="marcar(true)">
          Marcar revisado
        </v-btn>
        <v-btn small color="warning" :disabled="seleccion.length === 0" @click="marcar(false)">
          Quitar revisión
        </v-btn>
      </v-row>

      <v-snackbar v-model="snackbar.visible" :color="snackbar.color" top timeout="2500">
        {{ snackbar.text }}
      </v-snackbar>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import funcs from '../funcs';


export default {
  name: 'RevisionAcciones',
  computed: {
    ...mapState(['urlRaiz', 'perId']) // perId = responsable (PerIdSuperior)
  },
  data() {
    const y = new Date().getFullYear();
    return {
      loading: false,
      rows: [],
      seleccion: [],
      empleados: [],//kram filtro
      filtros: {
        revisado: false,
        year: y,
        empleadoSeleccionado: null,//kram filtro      
        perIdEmpleado: null     // solo el ID que mandaremos al backend 

      },
      anios: [y, y - 1, y - 2, y - 3, y - 4],
      headers: [
        { text: 'Fecha', value: 'FechaValoracion', width: 110 },
        { text: 'Empleado', value: 'Empleado', width: 220 },
        { text: 'Grupo', value: 'GrupoNombre', width: 220 },
        { text: 'Acción', value: 'TextoAccion', width: 420 },
        { text: 'Fecha revisión', value: 'FechaRevision', width: 130 }, // ⇦ aquí
        { text: 'Estado', value: 'Revisado', width: 120 }
      ],
      snackbar: { visible: false, color: '', text: '' },
    };
  },
  mounted() {
    this.loadData();
    this.loadEmpleados();
  },
  methods: {
    formatDate(v) { return funcs.formatDate(v, true); },
    auth() { return { Authorization: localStorage.getItem('token') }; },
    toast(t, type = 'success') { this.snackbar = { visible: true, color: type === 'error' ? 'red darken-2' : 'green darken-2', text: t }; },
    loadData() {
      this.loading = true;

      const params = {
        perIdSuperior: this.perId,
        empleadoId: this.filtros.empleadoSeleccionado || null,// kram si ponemos empleado para filtrar lo manda
        
      };
      if (this.filtros.revisado !== null && this.filtros.revisado !== undefined)
        params.revisado = this.filtros.revisado;
      if (this.filtros.year) params.year = Number(this.filtros.year);
      if (this.filtros.perIdEmpleado && Number(this.filtros.perIdEmpleado) > 0)
        params.perIdEmpleado = Number(this.filtros.perIdEmpleado);

      axios.get(`${this.urlRaiz}/api/valoracion-acciones/bandeja`, {
        headers: this.auth(),
        params

      })
        .then(res => {
          this.rows = res.data.map(x => ({

            ...x,//...x copia lo que tra el backend y le añade más parámetros
            //fecha original 
            FechaRevisionOriginal: x.FechaRevision,
            FechaRevisionFormatted: x.FechaRevision ? this.formatearFecha(x.FechaRevision) : '',// si hay fecha la formatea para que se vea bien, sino ''
            menu: false
          }));
        })
        .catch(() => this.toast('Error al cargar', 'error'))
        .finally(() => this.loading = false);
    },

    loadEmpleados() {
      this.loading = true;
      const AuthToken = localStorage.getItem('token');

      axios.get(`${this.urlRaiz}/api/valoracion/filtros/${this.perId}`, {
        headers: { Authorization: AuthToken }
      })
        .then(result => {
          this.empleados = result.data.empleados


        })
        .catch(() => {
          this.mostrarSnackbar("Error al cargar los empleados", "error");
        })
        .finally(() => {
          this.loading = false;
        });

    },

    marcar(revisado) {
      const ids = this.seleccion.map(x => x.ValoracionAccionId);
      axios.post(`${this.urlRaiz}/api/valoracion-acciones/review`, {
        Ids: ids, Revisado: revisado, FechaRevision: new Date()
      }, { headers: this.auth() })
        .then(() => { this.toast('Actualizado'); this.seleccion = []; this.loadData(); })
        .catch(() => this.toast('Error al actualizar', 'error'));
    },
    onToggleRevisado(item) {
      axios.post(`${this.urlRaiz}/api/valoracion-acciones/review`, {
        Ids: [item.ValoracionAccionId],
        Revisado: item.Revisado,
        FechaRevision: null
      }, { headers: this.auth() })
        .then(() => this.toast('Actualizado'))
        .catch(() => {
          item.Revisado = !item.Revisado; // revertir si falla
          this.toast('Error al actualizar', 'error');
        });
    },
    onEmpleadoChange() {
      this.loadData();         // Recargar lista filtrada
    },

    formatearFecha(fecha) {
      if (!fecha) return '';
      const d = new Date(fecha);
      const dia = ('0' + d.getDate()).slice(-2);
      const mes = ('0' + (d.getMonth() + 1)).slice(-2);
      const anio = d.getFullYear();
      return `${dia}-${mes}-${anio}`;
    },

    onGuardarFecha(item) {
      item.FechaRevisionFormatted = this.formatearFecha(item.FechaRevision);

      axios.post(`${this.urlRaiz}/api/valoracion-acciones/bulk-upsert`, [{
        ValoracionAccionId: item.ValoracionAccionId,
        ValoracionId: item.ValoracionId,
        GrupoPreguntaValoracionId: item.GrupoPreguntaValoracionId,
        TextoAccion: item.TextoAccion,
        FechaRevision: item.FechaRevision
      }], { headers: this.auth() })
        .then(() => {
          this.toast('Fecha actualizada');
          item.FechaRevisionEdited = false;
          item.FechaRevisionOriginal = item.FechaRevision;
          item.menu = false;
        })
        .catch(() => this.toast('Error al actualizar fecha', 'error'));
    },

    onCancelarFecha(item) {
      // Restaurar fecha original
      item.FechaRevision = item.FechaRevisionOriginal;
      item.FechaRevisionFormatted = this.formatearFecha(item.FechaRevisionOriginal);
      item.FechaRevisionEdited = false;
      item.menu = false;
    }
  }
};
</script>
